/**
 * Text message helpers for the editors (JT1-1857). The opt-out line matches the
 * API (apps/api/src/modules/sms-send/sms-body.ts), so the counter shows what
 * recipients actually get.
 */
export const SMS_OPT_OUT_FOOTER = 'Reply STOP to opt out';

const MENTIONS_OPT_OUT = /\b(stop|unsubscribe|opt out|opt-out)\b/i;

export function withOptOutFooter(body: string, enabled: boolean): string {
  if (!enabled || MENTIONS_OPT_OUT.test(body)) return body;
  return `${body}\n${SMS_OPT_OUT_FOOTER}`;
}

// GSM 03.38: the basic set costs one place, the extension set two. Anything else
// (emoji, curly quotes, most accents) switches the whole text to UCS-2.
const GSM_BASIC =
  '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà';
const GSM_EXTENDED = '^{}\\[~]|€\f';

/** Carrier segments a text uses: 160/153 characters for plain text, 70/67 otherwise. */
export function smsSegments(text: string): number {
  const chars = Array.from(text);
  const gsm = chars.every((c) => GSM_BASIC.includes(c) || GSM_EXTENDED.includes(c));
  if (gsm) {
    const length = chars.reduce((n, c) => n + (GSM_EXTENDED.includes(c) ? 2 : 1), 0);
    return length <= 160 ? 1 : Math.ceil(length / 153);
  }
  // UCS-2 counts UTF-16 code units, so an emoji takes two.
  const length = text.length;
  return length <= 70 ? 1 : Math.ceil(length / 67);
}
